import { createSelector } from '@ngrx/store';
import {
  selectEntityMap,
  selectEntitySlice,
} from '@core/state/entities/entity.selectors';
import { selectStagesForCurrentProject } from '@core/state/entities/stage/stage.selectors';
import { selectCurrentProject } from '@core/state/entities/project/project.selectors';
import _ from 'lodash-es';
import {selectCurrentProjectDetails} from '@core/state/entities/project-details/project-details.selectors';

export const getAllRecentStages = createSelector(
  selectEntitySlice('stageUsages'),
  selectEntityMap('stages'),
  (stageUsagesState, stageEntityMap) => {
    if (!stageUsagesState || !stageEntityMap) {
      return [];
    }
    return stageUsagesState.allIds
      .map((suId) => stageUsagesState.byId[suId])
      .sort(
        (a, b) =>
          (a.lastAccessed ? Date.parse(a.lastAccessed) : 0) -
          (b.lastAccessed ? Date.parse(b.lastAccessed) : 0)
      )
      .reverse()
      .map((su) => stageEntityMap[su?.id])
      .filter((stage) => !!stage);
  }
);

export const getAllFavouriteStages = createSelector(
  selectEntityMap('stageUsages'),
  getAllRecentStages,
  (stageUsagesEntityMap, recentStages) =>
    stageUsagesEntityMap
      ? recentStages.filter((p) => stageUsagesEntityMap[p?.id].favourite)
      : []
);

export const getRecentStagesForCurrentProject = createSelector(
  selectCurrentProjectDetails,
  selectEntitySlice('stageUsages'),
  selectEntityMap('stages'),
  (currentProjectDetails, stageUsagesState, stageEntityMap) => {
    if (!currentProjectDetails || !stageUsagesState || !stageEntityMap) {
      return [];
    }
    return currentProjectDetails.stages
      .map((stageId) => stageUsagesState.byId[stageId])
      .sort(
        (a, b) =>
          (a.lastAccessed ? Date.parse(a.lastAccessed) : 0) -
          (b.lastAccessed ? Date.parse(b.lastAccessed) : 0)
      )
      .reverse()
      .map((pu) => stageEntityMap[pu?.id])
      .filter((p) => !!p);
  }
);

export const getFavouriteStagesForCurrentProject = createSelector(
  selectEntityMap('stageUsages'),
  getRecentStagesForCurrentProject,
  (stageUsagesEntityMap, recentStagesForCurrentProject) =>
    stageUsagesEntityMap
      ? recentStagesForCurrentProject.filter(
          (p) => stageUsagesEntityMap[p?.id].favourite
        )
      : []
);

export const selectStagesForCurrentProjectWithFavouritesFirst = createSelector(
  getFavouriteStagesForCurrentProject,
  selectStagesForCurrentProject,
  (favouriteStages, allStages) => _.union(favouriteStages, allStages)
);
